// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_navbar__LmReW {
  padding: 10px 20px !important;
}
@media (min-width: 992px) {
  .Header_navbar__LmReW {
    padding: 10px 40px !important;
  }
}
@media (min-width: 1600px) {
  .Header_navbar__LmReW {
    padding-left: calc(40px + 0.5 * (100vw - 1600px)) !important;
    padding-right: calc(40px + 0.5 * (100vw - 1600px)) !important;
  }
}

.Header_navLabel__bjIaJ {
  font-family: "Barlow", Helvetica, sans-serif;
}

.Header_logoBrandMark__FTZQn {
  padding: 2px;
  background-color: rgba(255, 255, 255, 0.85);
  margin-right: -10px;
}

.Header_languageItem__YMlRh {
  text-align: right !important;
}

.Header_languageName__qhV6h {
  margin-right: 15px;
  font-family: "Barlow", Helvetica, sans-serif;
}

.Header_langDropdown__fyLhs {
  margin-left: 7px;
}
.Header_langDropdown__fyLhs a {
  color: #aaaaaa !important;
}
.Header_langDropdown__fyLhs a:hover {
  color: #d9d9d9 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACC,6BAAA;AAFD;AAGC;EAFD;IAGE,6BAAA;EAAA;AACF;AACC;EALD;IAME,4DAAA;IACA,6DAAA;EAEA;AACF;;AACA;EACC,4CCSY;ADPb;;AACA;EACC,YAAA;EACA,2CAAA;EACA,mBAAA;AAED;;AACA;EACC,4BAAA;AAED;;AACA;EACC,kBAAA;EACA,4CCNY;ADQb;;AAGA;EACC,gBAAA;AAAD;AAEC;EACC,yBAAA;AAAF;AAEE;EACC,yBAAA;AAAH","sourcesContent":["@import '../../styles/colors';\n@import '../../styles/variables';\n\n.navbar {\n\tpadding: 10px 20px !important;\n\t@media (min-width: 992px) {\n\t\tpadding: 10px 40px !important;\n\t}\n\t@media (min-width: 1600px) {\n\t\tpadding-left: calc(40px + 0.5 * (100vw - 1600px)) !important;\n\t\tpadding-right: calc(40px + 0.5 * (100vw - 1600px)) !important;\n\t}\n}\n\n.navLabel {\n\tfont-family: $ff-primary;\n}\n\n.logoBrandMark {\n\tpadding: 2px;\n\tbackground-color: rgba(255, 255, 255, .85);\n\tmargin-right: -10px;\n}\n\n.languageItem {\n\ttext-align: right !important;\n}\n\n.languageName {\n\tmargin-right: 15px;\n\tfont-family: $ff-primary;\n}\n\n// this is just to force the gray color on the down caret, which for unknown\n// reasons renders black on localhost and blue on stage\n.langDropdown {\n\tmargin-left: 7px;\n\n\ta {\n\t\tcolor: $gray-color !important;\n\n\t\t&:hover {\n\t\t\tcolor: $gray-input-border !important;\n\t\t}\n\t}\n}\n","// LOGO URL\n$logo-url: 'https://res.cloudinary.com/croative/image/upload/v1666945086/benchmark/logo-220x220.png';\n// repeated in constants.js\n\n// FONT SIZES\n$fs-h1: 3.3rem;\n$fs-h2-large: 2.5rem;\n$fs-h2: 1.8rem;\n$fs-h3: 1.4rem;\n$fs-h4: 1.25rem;\n$fs-h5: 1.1rem;\n$fs-sectionTitle: 40px;\n$fs-body: 22px;\n$fs-label: 20px;\n$fs-small: 16px;\n$fs-very-small: 14px;\n\n// Font weights\n$fw-light: 300;\n$fw-normal: 400;\n$fw-medium: 500;\n$fw-semi-bold: 600;\n\n// Font Families\n$ff-primary: 'Barlow', Helvetica, sans-serif;\n$ff-secondary: 'Barlow', Helvetica, sans-serif;\n//$ff-secondary: 'Source Sans Pro', Helvetica, sans-serif;\n\n$max-width: 1420px;\n\n$answer-radio-grid-height: 60px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Header_navbar__LmReW`,
	"navLabel": `Header_navLabel__bjIaJ`,
	"logoBrandMark": `Header_logoBrandMark__FTZQn`,
	"languageItem": `Header_languageItem__YMlRh`,
	"languageName": `Header_languageName__qhV6h`,
	"langDropdown": `Header_langDropdown__fyLhs`
};
export default ___CSS_LOADER_EXPORT___;
